import React, { ReactNode, useMemo } from 'react';

import { cn } from '@/lib/utils';

export const Card = ({
  children,
  title,
  subTitle,
  extra,
  className,
  headerClassName
}: {
  children?: ReactNode;
  title?: ReactNode;
  subTitle?: ReactNode;
  extra?: ReactNode;
  className?: string;
  headerClassName?: string;
}) => {
  const classes = useMemo(() => {
    const classes = ['border border-gray-200 rounded-[8px] overflow-hidden'];
    if (!title) {
      classes.push('py-[16px] px-[24px]');
    }
    return classes;
  }, [title]);
  const headClasses = useMemo(() => {
    const classes = ['flex justify-between items-center py-[20px] px-[24px]'];
    if (children) {
      classes.push('border-b border-gray-200');
    }
    return classes;
  }, [children]);
  return (
    <div className={cn(classes, className)}>
      {title ? (
        <div className={cn(headClasses, headerClassName)}>
          <div>
            <div className="font-medium text-lg text-gray-900">{title}</div>
            <div className="text-sm text-gray-500">{subTitle}</div>
          </div>
          {extra}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export const FormFieldCard = ({
  extra,
  title,
  description,
  children,
  className
}: {
  extra?: ReactNode;
  title?: ReactNode;
  description?: string;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn('flex-1 py-5 px-6', className)}>
      <div className="flex justify-between items-center">
        <div>
          <div className="text-sm text-gray-900">{title}</div>
          <div className="text-xs text-gray-400 mt-[4px]">{description}</div>
        </div>
        {extra}
      </div>
      <div className={'pt-4'}>{children}</div>
    </div>
  );
};
